export default __webpack_public_path__ + "static/media/Computer Science.9a5452c5.png";